import PaymentTable from "components/pageSection/Payments/PaymentTable";
import React, { useEffect, useState } from "react";
import { Wrapper } from "./Payments.styled";
import { callPostApiWithAuth, callGetApiWithAuth } from "utils/api";

const Payments = () => {
  const initalValues = {
    datePaid: "",
    installCommission: "",
    CAPPayment: "",
    clawbackBONUS: "",
    totalinPeriod: "",
    prevPaid: "",
    totalProjectCommission: "",
    projectId: "",
  };
  const [formData, setFormData] = useState(initalValues);
  const [isLoading, setIsLoading] = useState(false);
  const [payment, setPayment] = useState([]);

  const successPostPaymentCall = (data) => {
    setFormData(initalValues);
    callGetApi();
  };
  const failPostPaymentCall = (err) => {
    console.log(err);
  };

  const successGetPaymentCall = (data) => {
    setPayment(data);
    setIsLoading(false);
  };
  const failGetPaymentCall = (err) => {
    console.log(err);
    setIsLoading(false);
  };
  const callPostApi = (data) => [
    callPostApiWithAuth(
      "addPayment",
      data,
      successPostPaymentCall,
      failPostPaymentCall
    ),
  ];
  const callGetApi = () => {
    callGetApiWithAuth(
      "getAllPayments",
      successGetPaymentCall,
      failGetPaymentCall
    );
  };

  useEffect(() => {
    callGetApi();
    setIsLoading(true);
  }, []);

  return (
    <Wrapper>
      <PaymentTable
        formData={formData}
        payment={payment}
        setFormData={setFormData}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        callPostApi={callPostApi}
      />
    </Wrapper>
  );
};

export default Payments;
